import api from "./Api";

class AssistantReportService {
  normalizeOption(option) {
    return {
      value: option?.value ?? option?.Value ?? "",
      label: option?.label ?? option?.Label ?? "",
    };
  }

  normalizeFilter(filter) {
    return {
      key: filter?.key ?? filter?.Key ?? "",
      fieldPath: filter?.fieldPath ?? filter?.FieldPath ?? "",
      label: filter?.label ?? filter?.Label ?? "",
      type: filter?.type ?? filter?.Type ?? "",
      multiple: filter?.multiple ?? filter?.Multiple ?? false,
      placeholder: filter?.placeholder ?? filter?.Placeholder ?? "",
      helpText: filter?.helpText ?? filter?.HelpText ?? "",
      selectedValues: filter?.selectedValues ?? filter?.SelectedValues ?? [],
      options: (filter?.options ?? filter?.Options ?? []).map((option) =>
        this.normalizeOption(option)
      ),
    };
  }

  normalizeMetric(metric) {
    return {
      key: metric?.key ?? metric?.Key ?? "",
      label: metric?.label ?? metric?.Label ?? "",
      value: metric?.value ?? metric?.Value ?? 0,
      format: metric?.format ?? metric?.Format ?? "number",
      tone: metric?.tone ?? metric?.Tone ?? "dark",
    };
  }

  normalizeColumn(column) {
    return {
      key: column?.key ?? column?.Key ?? "",
      label: column?.label ?? column?.Label ?? "",
      format: column?.format ?? column?.Format ?? "text",
    };
  }

  normalizeChartSeries(series) {
    return {
      name: series?.name ?? series?.Name ?? "",
      data: series?.data ?? series?.Data ?? [],
    };
  }

  normalizeChart(chart) {
    if (!chart) {
      return null;
    }

    return {
      type: chart?.type ?? chart?.Type ?? "bar",
      title: chart?.title ?? chart?.Title ?? "",
      categories: chart?.categories ?? chart?.Categories ?? [],
      series: (chart?.series ?? chart?.Series ?? []).map((series) =>
        this.normalizeChartSeries(series)
      ),
    };
  }

  normalizeResponse(result) {
    const normalizedResult = result || {};
    const data = normalizedResult.Data || normalizedResult.data || null;

    if (!data) {
      return normalizedResult;
    }

    normalizedResult.Data = {
      status: data.status ?? data.Status ?? "",
      reportType: data.reportType ?? data.ReportType ?? "",
      dataSourceLabel: data.dataSourceLabel ?? data.DataSourceLabel ?? "",
      title: data.title ?? data.Title ?? "",
      description: data.description ?? data.Description ?? "",
      prompt: data.prompt ?? data.Prompt ?? "",
      context: data.context ?? data.Context ?? "",
      summary: data.summary ?? data.Summary ?? "",
      generatedAt: data.generatedAt ?? data.GeneratedAt ?? null,
      dateInitial: data.dateInitial ?? data.DateInitial ?? null,
      dateFinal: data.dateFinal ?? data.DateFinal ?? null,
      previewItems: data.previewItems ?? data.PreviewItems ?? [],
      columns: (data.columns ?? data.Columns ?? []).map((column) =>
        this.normalizeColumn(column)
      ),
      rows: data.rows ?? data.Rows ?? [],
      metrics: (data.metrics ?? data.Metrics ?? []).map((metric) =>
        this.normalizeMetric(metric)
      ),
      chart: this.normalizeChart(data.chart ?? data.Chart ?? null),
      suggestedFilters: (
        data.suggestedFilters ??
        data.SuggestedFilters ??
        []
      ).map((filter) => this.normalizeFilter(filter)),
      confirmedPlan: data.confirmedPlan ?? data.ConfirmedPlan ?? null,
      warnings: data.warnings ?? data.Warnings ?? [],
    };

    return normalizedResult;
  }

  request(payload) {
    return api
      .post("/v1/Assistant/Reports/Generate", payload)
      .then((response) => {
        return this.normalizeResponse(response.data);
      });
  }

  refresh(payload) {
    return api
      .post("/v1/Assistant/Reports/Refresh", payload)
      .then((response) => {
        return this.normalizeResponse(response.data);
      });
  }

  GeneratePreview(payload) {
    return this.request({
      ...(payload || {}),
      execute: false,
    });
  }

  Generate(payload) {
    return this.request({
      ...(payload || {}),
      execute: true,
    });
  }

  Refresh(payload) {
    return this.refresh({
      ...(payload || {}),
      execute: true,
    });
  }
}

export default new AssistantReportService();
